import { render } from "./ProjectParticipationEditWidget.vue?vue&type=template&id=478fcdea&ts=true"
import script from "./ProjectParticipationEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectParticipationEditWidget.ts?vue&type=script&lang=ts&external"

import "./ProjectParticipationEditWidget.vue?vue&type=style&index=0&id=478fcdea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__